import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const TZ = {
  "Africa/Johannesburg": "ZA", "Africa/Lagos": "NG", "Africa/Nairobi": "KE", "Africa/Accra": "GH",
  "Africa/Cairo": "EG", "Africa/Casablanca": "MA", "Africa/Algiers": "DZ", "Africa/Tunis": "TN",
  "Africa/Tripoli": "LY", "Africa/Khartoum": "SD", "Africa/Juba": "SS", "Africa/Addis_Ababa": "ET",
  "Africa/Asmara": "ER", "Africa/Djibouti": "DJ", "Africa/Mogadishu": "SO", "Africa/Kampala": "UG",
  "Africa/Kigali": "RW", "Africa/Bujumbura": "BI", "Africa/Dar_es_Salaam": "TZ", "Africa/Lusaka": "ZM",
  "Africa/Harare": "ZW", "Africa/Maputo": "MZ", "Africa/Blantyre": "MW", "Africa/Gaborone": "BW",
  "Africa/Windhoek": "NA", "Africa/Maseru": "LS", "Africa/Mbabane": "SZ", "Africa/Luanda": "AO",
  "Africa/Kinshasa": "CD", "Africa/Lubumbashi": "CD", "Africa/Brazzaville": "CG", "Africa/Libreville": "GA",
  "Africa/Douala": "CM", "Africa/Malabo": "GQ", "Africa/Bangui": "CF", "Africa/Ndjamena": "TD",
  "Africa/Niamey": "NE", "Africa/Bamako": "ML", "Africa/Ouagadougou": "BF", "Africa/Dakar": "SN",
  "Africa/Banjul": "GM", "Africa/Bissau": "GW", "Africa/Conakry": "GN", "Africa/Freetown": "SL",
  "Africa/Monrovia": "LR", "Africa/Abidjan": "CI", "Africa/Lome": "TG", "Africa/Porto-Novo": "BJ",
  "Africa/Nouakchott": "MR", "Atlantic/Cape_Verde": "CV", "Africa/Sao_Tome": "ST",
  "Indian/Antananarivo": "MG", "Indian/Comoro": "KM", "Indian/Mauritius": "MU", "Indian/Mahe": "SC",
};

const detect = () => {
  try {
    return TZ[Intl.DateTimeFormat().resolvedOptions().timeZone] || "ZA";
  } catch {
    return "ZA";
  }
};

const Ctx = createContext(null);

export const CountryProvider = ({ children }) => {
  const [countries, setCountries] = useState([]);
  const [code, setCode] = useState(() => localStorage.getItem("ac_country") || detect());
  const [country, setCountryObj] = useState(null);

  const loadList = useCallback(() => api.get("/countries").then((r) => setCountries(r.data)), []);
  useEffect(() => { loadList(); }, [loadList]);

  useEffect(() => {
    api.get(`/countries/${code}`).then((r) => setCountryObj(r.data)).catch(() => setCode("ZA"));
  }, [code]);

  const setCountry = (c) => {
    localStorage.setItem("ac_country", c);
    setCode(c);
  };

  return (
    <Ctx.Provider value={{ countries, code, country, setCountry, reload: loadList }}>
      {children}
    </Ctx.Provider>
  );
};

export const useCountry = () => useContext(Ctx);
